/* eslint-disable import/prefer-default-export */
import React, { useContext } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { getDefaultOptions, getDefaultUrl } from './campaign-fetch-config';
import type {
  CampaignFetchContextValue,
  CampaignFetchProviderProps,
  CampaignInstrumentation,
  CampaignServerContextLike,
} from './types';

export const CampaignFetchContext = React.createContext<CampaignFetchContextValue>({});

export const CampaignFetchProvider = ({
  url,
  options,
  children,
}: CampaignFetchProviderProps) => {
  const serverContext = useContext(ServerContext) as unknown as CampaignServerContextLike;
  let finalUrl = url || getDefaultUrl(serverContext);
  finalUrl = finalUrl.replace(/\/+$/, '');

  const instrumentation = useContext(InstrumentationContext) as CampaignInstrumentation;
  const finalOptions = getDefaultOptions(serverContext, instrumentation);

  if (options && options.headers) {
    finalOptions.headers = { ...finalOptions.headers, ...options.headers };
  }

  return (
    <CampaignFetchContext.Provider value={{
      url: finalUrl,
      options: finalOptions,
    }}
    >
      {children}
    </CampaignFetchContext.Provider>
  );
};
